import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const QtAccordion = ({ title, children, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  const panelId = `qt-acc-${title.replace(/\s/g, '-').slice(0, 24)}`;

  return (
    <div className="qt-accordion">
      <button
        type="button"
        className="qt-accordion__trigger"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((p) => !p)}
      >
        {title}
        <ChevronDown size={20} style={{ transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }} />
      </button>
      <div id={panelId} className="qt-accordion__panel" hidden={!open}>
        {children}
      </div>
    </div>
  );
};

export default QtAccordion;